import { render, staticRenderFns } from "./InspectionSummary.vue?vue&type=template&id=f6800120&scoped=true&"
import script from "./InspectionSummary.vue?vue&type=script&lang=js&"
export * from "./InspectionSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6800120",
  null
  
)

export default component.exports